import './home.scss';

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { Row, Col, Alert } from 'reactstrap';

import { useAppSelector, useAppDispatch } from 'app/config/store';
import { login } from 'app/shared/reducers/authentication';
import LoginModal from 'app/modules/login/login-modal';

export const Home = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const account = useAppSelector(state => state.authentication.account);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const loginError = useAppSelector(state => state.authentication.loginError);

  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
    }
  }, [isAuthenticated]);

  const handleLogin = (username, password, rememberMe = false) => {
    dispatch(login(username, password, rememberMe));
  };

  const handleCloseModal = () => {
    setShowLoginModal(false);
  };

  // Redirect to revenue page after successful login
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/revenue');
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <Row>
        <Col md="3" className="pad">
          <span className="hipster rounded" />
        </Col>
        <Col md="9">
          <h2>{/* <Translate contentKey="home.title">Title</Translate> */}</h2>
          <p className="lead">{/* <Translate contentKey="home.subtitle">Subtitle</Translate> */}</p>
          {account?.login ? (
            <div>
              <p>Welcome</p>
            </div>
          ) : (
            <div>
              <p>Please log in to access the application.</p>
            </div>
          )}
        </Col>
      </Row>

      {!isAuthenticated && (
        <LoginModal showModal={showLoginModal} handleLogin={handleLogin} handleClose={handleCloseModal} loginError={loginError} />
      )}
    </>
  );
};

export default Home;
